var moduleMap = {
	"./ChairsideModule": () => {
		return Promise.all([__webpack_require__.e(539), __webpack_require__.e(5577), __webpack_require__.e(5292), __webpack_require__.e(6346), __webpack_require__.e(8283), __webpack_require__.e(6384), __webpack_require__.e(2783), __webpack_require__.e(6737), __webpack_require__.e(9580), __webpack_require__.e(8738), __webpack_require__.e(8466), __webpack_require__.e(9938), __webpack_require__.e(6652), __webpack_require__.e(2494), __webpack_require__.e(7687), __webpack_require__.e(4470), __webpack_require__.e(78)]).then(() => (() => ((__webpack_require__(26575)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});